var trackedElements = [
    { selector: '/pages/book-an-appointment', type: 'href', eventName: 'bookAnAppointment' },
    { selector: '#ProductDrawer2-nav', type: 'data-menu', eventName: 'contactAnAmbassador' },
    { selector: '.wk-add-product', type: 'class', eventName: 'addToWishlist' }
];

function attachEventListeners() {
    trackedElements.forEach(function(item) {
        var elements = [];

        if (item.type === 'class') {
            elements = document.querySelectorAll(item.selector);
        } else if (item.type === 'id') {
            var element = document.getElementById(item.selector);
            elements = element ? [element] : [];
        } else if (item.type === 'href') {
            document.querySelectorAll('a').forEach(function(element) {
                var href = element.getAttribute('href');
                if (href && href.includes(item.selector)) {
                    elements.push(element);
                }
            });
        } else if (item.type.startsWith('data-')) {
            document.querySelectorAll('[' + item.type + ']').forEach(function(element) {
                elements.push(element);
            });
        }

        console.log('Tracked Elements for:', item.selector, elements);
        console.log(document.querySelectorAll('.wk-add-product'));

        elements.forEach(function(element) {
            element.addEventListener('click', function() {
                // console.log('Element clicked:', element);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': item.eventName,
                    'elementId': element.id,
                    'elementClasses': element.className,
                    'elementText': element.textContent.trim(),
                    'pageUrl': window.location.href,
                    'clickedHref': element.getAttribute('href') || '',
                    'wishlistAddId': element.getAttribute('data-wk-add-product') || '',
                    'clickedSelector': item.selector,
                    [item.type]: element.getAttribute(item.type) || ''
                });
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
        attachEventListeners();
    }, 2000);
});

